function asString(value) {
    return typeof value === 'string' ? value : value != null ? String(value) : '';
}
/**
 * Maps store / dynamic-form gift fields to the GraphQL deal payload.
 */
export function buildGiftDealInput(values) {
    const isGift = asString(values.isGift) === '1';
    const sendEmail = asString(values.giftSendEmail) === '1';
    if (!isGift) {
        return {
            giftToName: null,
            giftToEmail: null,
            giftMessage: null,
            giftSendAt: null
        };
    }
    return {
        giftToName: asString(values.giftToName).trim() || null,
        giftToEmail: sendEmail
            ? asString(values.giftToEmail).trim() || null
            : null,
        giftMessage: asString(values.giftMessage).trim() || null,
        giftSendAt: sendEmail ? asString(values.giftSendAt).trim() || null : null
    };
}
/**
 * Validates gift fields before approve / create.
 * Returns an error message or null.
 */
export function validateGiftDealInput(values) {
    const isGift = asString(values.isGift) === '1';
    if (!isGift) {
        return null;
    }
    if (!asString(values.giftToName).trim()) {
        return t('Please enter the recipient name.');
    }
    if (asString(values.giftSendEmail) !== '1') {
        return null;
    }
    if (!asString(values.giftToEmail).trim()) {
        return t('Please enter the recipient email.');
    }
    if (!asString(values.giftSendAt).trim()) {
        return t('Please choose a send date.');
    }
    return null;
}
